// extracted by mini-css-extract-plugin
export default {"cardscontainer":"Shop_cardscontainer__-Qkg0","noresults":"Shop_noresults__5lAPG"};